const imageBase = 'https://lightbox-prod.imgix.net/images/static'
const imageUpdateBase = 'https://lightbox-prod.imgix.net/images/uploads'
const hotspotImageAssets = 'https://lightbox-prod.imgix.net/images/assets'
const ctaText = 'Start Watching'
const ctaUrl = '/signup/account'

const moviesP1 = {
  image: `${hotspotImageAssets}/THUMBNAIL_WIDE_mac_11730725_2164748C-44F0-4665-B95AFB88B0D802C1.jpg`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_11730725_18016569-4331-4754-BD7A7532A6521D36.png`,
  line1: 'Twisters',
  line2: 'The sky isn’t falling,<br />it’s coming for you.',
  line3: '',
  copyright: '© 2024 Warner Bros. Entertainment Inc., Universal Pictures, Domain Pictures, & Amblin Entertainment. All rights reserved.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const moviesP2 = {
  image: `${imageUpdateBase}/1730791244588-transformers-one-2024-neon-hotspot-web-mobile.jpg`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_11735474_18B5D433-FA5D-43D2-A99B4116E20970A5.png`,
  line1: 'Transformers: One',
  line2: 'Before the war,<br />there was a brotherhood.',
  line3: '',
  copyright: '© 2024 Par. Pics. TM Hasbro.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const moviesP3 = {
  image: `${hotspotImageAssets}/PROMO_WIDE_mac_11730732_EC36762D-F23E-46AD-83B1915075705704.jpg?auto=format&fit=crop&crop=faces%2Cright&ar=16%3A9&ixlib=react-9.0.1`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_11730732_2FEFB8B3-A8C2-4868-904438D9962E8D57.png`,
  line1: 'It Ends With Us',
  line2: 'Sometimes the hardest choices break your heart.',
  line3: '',
  copyright: '© 2024 Columbia Pictures Industries, Inc., Wayfarer Studios and TSG Entertainment II. All Rights Reserved.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const moviesP4 = {
  image: `${hotspotImageAssets}/PROMO_WIDE_mac_11758383_438F1004-0C07-42E1-9AD74EC8548114AF.jpg?auto=format&fit=crop&crop=faces%2Cright&ar=16%3A9&ixlib=react-9.0.1`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_11758383_D5084563-A8A5-424D-87E88CB76B800041.png`,
  line1: 'Venom: The Last Dance',
  line2: 'Til death do they part.<br />Witness the epic conclusion.',
  line3: '',
  copyright: '© 2024 Columbia Pictures Industries, Inc.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const moviesP5 = {
  image: `${hotspotImageAssets}/PROMO_WIDE_mac_11718416_213944FF-3ACB-4045-AB0FE5319C73FD95.jpg?auto=format&fit=crop&crop=faces%2Cright&ar=16%3A9&ixlib=react-9.0.1`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_11718416_5F9AA8AE-7D89-4E60-B26F9D55C612439A.png`,
  line1: 'Furiosa: A Mad Max Saga',
  line2: 'Her road to vengeance begins.',
  line3: '',
  copyright: '© 2024 Warner Bros. Ent. All Rights Reserved.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const tvP1 = {
  image: `${imageUpdateBase}/1745801108350-the-last-of-us-s2-e3-hotspot-web-mobile.jpg`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_sh_138692_B14D058F-EB24-4AE8-AE50DAF1BCA48856.png`,
  line1: 'The Last of Us',
  line2: 'When you’re lost in the darkness,<br />look for the light.',
  line3: '',
  copyright: '© 2025 Home Box Office, Inc. All rights reserved. HBO® and all related channels and service marks are the property of Home Box Office, Inc.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const tvP2 = {
  image: `${hotspotImageAssets}/PROMO_WIDE_mac_sh_121495_927618D3-45A8-487B-97CA10D7D1BBF1DE.jpg?auto=format&fit=crop&crop=faces%2Cright&ar=16%3A8&ixlib=react-9.0.1`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_sh_121495_2659FD37-452C-439B-B876649AFCA1A471.png`,
  line1: 'The White Lotus',
  line2: 'A luxury escape where secrets and sins surface.',
  line3: '',
  copyright: '© 2025 Home Box Office, Inc. All rights reserved.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const tvP3 = {
  image: `${imageUpdateBase}/1745867174448-the-handmaids-tale-s6-e6-hotspot-web-mobile.jpg`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_sh_94475_B4060E18-7D1B-457D-8991E9490FD2DAE0.png`,
  line1: 'The Handmaid’s Tale',
  line2: 'Blessed be the fight.<br />Freedom is the ultimate rebellion.',
  line3: '',
  copyright: '© 2025 MGM Television Entertainment Inc. and Relentless Productions, LLC. All Rights Reserved. THE HANDMAID’S TALE is a trademark of Metro-Goldwyn-Mayer Studios Inc. All Rights Reserved.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const tvP4 = {
  image: `${hotspotImageAssets}/PROMO_WIDE_mac_sh_130452_3DDF6D09-E8EF-409C-803FCF657EF7FE79.jpg?auto=format&fit=crop&crop=faces%2Cright&ar=16%3A8&ixlib=react-9.0.1`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_sh_130452_58870A11-23F9-4BAF-80572348F7790736.png`,
  line1: 'And Just Like That',
  line2: 'Getting older is messy.<br />Fabulous is forever.',
  line3: '',
  copyright: '© 2025 WarnerMedia Direct, LLC. All Rights Reserved.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const tvP5 = {
  image: `${hotspotImageAssets}/PROMO_WIDE_mac_sh_166919_1C326B84-7ADB-4EEB-A24734D5DEA819B8.jpg?auto=format&fit=crop&crop=faces%2Cright&ar=16%3A8&ixlib=react-9.0.1`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_sh_166919_4ACE88D7-F4CE-4F4C-BA4D70D4F09157F1.png`,
  line1: 'Happy Valley',
  line2: 'A tough cop faces crime and tragedy in a sleepy English town.',
  line3: '',
  copyright: '© Lookout Point 2022.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const kidsP1 = {
  image: `${imageBase}/guest-hotspot-kids-1.14-5-2018.jpg`,
  line1: 'Paw Patrol',
  line2: 'No job is too big, <br /> no pup is too small!',
  line3: '',
  copyright: '© 2018 Spin Master PAW Productions Inc. © 2018 Viacom International Inc. All Rights Reserved',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const kidsP2 = {
  image: `${imageUpdateBase}/1602456288401-bluey-s1-cc2.jpg`,
  titleTreatmentImage: `${hotspotImageAssets}/TITLE_TREATMENT_mac_sh_94947_851A3F39-92A7-4CE4-A354D969FC017231.png`,
  croppingOption: 'edge',
  line1: 'Bluey',
  line2: 'The adventures of the lovable Blue Heeler family',
  line3: '',
  copyright: 'Ludo Studio 2019',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const kidsP3 = {
  image: `${imageUpdateBase}/1687912267899-blaze-and-the-monster-machines-s6_hploggedout.jpg`,
  line1: 'Blaze and The Monster Machines',
  line2: 'Race into adventure<br />Leeeet’s Blaaaaze!',
  line3: '',
  copyright: '© 2023 Viacom International Inc. All Rights Reserved.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const kidsP4 = {
  image: `${imageUpdateBase}/1523919014083-spongebobbs.jpg`,
  croppingOption: 'edge',
  line1: 'SpongeBob SquarePants',
  line2: 'Who lives in a pineapple<br />under the sea...?',
  line3: '',
  copyright: '© 2020 Viacom International Inc. Created by Stephen Hillenburg.',
  cta: {
    text: ctaText,
    url: ctaUrl
  }
}

const tv = {
  slides: [
    tvP1,
    tvP2,
    tvP3,
    tvP4,
    tvP5
  ]
}

const movies = {
  slides: [
    moviesP1,
    moviesP2,
    moviesP3,
    moviesP4,
    moviesP5
  ]
}

const kids = {
  slides: [
    kidsP1,
    kidsP2,
    kidsP3,
    kidsP4
  ]
}

const homeHero = {
  image: 'https://lightbox-prod.imgix.net/images/uploads/breadth-of-content-image_Jul_2022.jpg',
  line1: 'Binge the best',
  line2: 'Watch the latest TV shows, movies, and all your favourites.',
  line3: '',
  copyright: '',
  cta: {
    text: ctaText,
    url: ctaUrl
  },
  isGuestHome: true,
  msgForBasicDiscount: `
  Limited time offer - Get NEON Basic plan for only $9.99 a month for 3 months. Offer ends 8/12/2024 <a target="_blank" href="/basic-plan-offer" style="color:white;text-decoration:underline;text-underline-offset:6px">T&Cs apply</a>.`,
  msgForStandardDiscount: `
  Limited Time Offer. Get NEON Standard plan for only $14.99 a month for 3 months. After 3 Months your plan will auto-renew at $23.99/m. Offer ends 29 June 2025. <a target="_blank" href="https://help.neontv.co.nz/support/solutions/articles/64000308741-2025-neon-standard-plan-discount-faqs-and-terms" style="color:white;text-decoration:underline;text-underline-offset:6px">T&C's apply</a>.`,
  msgForAnnualDiscount: `
  Limited Time Offer. Take off 50% for 3 months on a Neon Annual Plan. Offer ends 16 November 2024. <a target="_blank" href="/annual-plan-offer" style="color:white;text-decoration:underline;text-underline-offset:6px">T&C's apply</a>.`
}

const home = {
  slides: [
    homeHero
  ]
}

export default {
  home,
  tv,
  movies,
  kids,
  about: home
}
